import './lib/css'
import './lib/script'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import EventBus from './lib/EventBus'
import axios from 'axios'
import lodash from 'lodash'
import Base64 from 'Base64'

import NProgress from 'nprogress'

import '../node_modules/nprogress/nprogress.css'

import "prismjs";
import "prismjs/themes/prism.css";
//vue-prism-editor dependency
import "vue-prism-editor/dist/VuePrismEditor.css";


// register the plugin on vue
import Toasted from 'vue-toasted';

Vue.use(Toasted)


import * as vClickOutside from 'v-click-outside-x';

import ToggleButton from 'vue-js-toggle-button'

import VueSweetalert2 from 'vue-sweetalert2'

import jwtDecode from 'jwt-decode'
import GAuth from 'vue-google-oauth2'

import Popover from 'vue-js-popover'

import VueRangedatePicker from 'vue-rangedate-picker'
import store from './vuex/store'
import config from './config'
import VueMoment from 'vue-moment'
import BootstrapVue from 'bootstrap-vue'


Vue.use(VueSweetalert2);
Vue.use(ToggleButton)
Vue.use(vClickOutside)
Vue.use(VueRangedatePicker)
Vue.use(VueMoment)
Vue.use(BootstrapVue);


Vue.use(GAuth, {
    clientId: "322008598529-2evk6u4p8cttqqk5rmacc0a5m6aup0nr.apps.googleusercontent.com",
    scope: 'profile email'
})


var author = {
    init: function () {
        let token = localStorage.getItem('access_token')
        return jwtDecode(token)
    },
    email: function () {
        let user = this.init()
        return user.email
    },
    name: function () {
        let user = this.init()
        return user.name
    },
    domain: function () {
        let user = this.init()
        return user.domain
    },
    brand: function () {
        let user = this.init()
        return user.domain.split('.')[0]
    },
    isExpire: function () {
        let user = this.init()
        if (this.$moment(user.expire_date) < this.$moment())
            return true
        return false
    },
    refreshToken: async function () {
        let access_token = localStorage.getItem('access_token')
        let response = await axios
            .post(config.api + "tokens/auth", {
                refreshToken: access_token,
                grantType: "refresh_token",
                clientId: "website"
            })
        //  console.log('renew access token')
        localStorage.setItem('access_token', response.data.access_token)
        axios.defaults.headers.common['Authorization'] = response.data.access_token
    }
}


var helper = {
    wait: function (time) {
        return new Promise(resolve => setTimeout(resolve, time));
    },
    collection: function (name) {
        return 'https://' + author.domain() + '/' + name
    },
    url: function (id, name) {
        return 'https://' + author.domain() + '/product/' + this.slug(name) + '-' + id
    },
    numberFormat: function (number, decimals, dec_point, thousands_sep) {
        // Strip all characters but numerical ones.
        number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
        var n = !isFinite(+number) ? 0 : +number,
            prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
            sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
            dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
            s = '',
            toFixedFix = function (n, prec) {
                var k = Math.pow(10, prec);
                return '' + Math.round(n * k) / k;
            };
        // Fix for IE parseFloat(0.55).toFixed(0) = 0;
        s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
        if (s[0].length > 3) {
            s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
        }
        if ((s[1] || '').length < prec) {
            s[1] = s[1] || '';
            s[1] += new Array(prec - s[1].length + 1).join('0');
        }
        return s.join(dec);
    },
    slug: function (string) {
        const a = 'àáäâãåèéëêìíïîòóöôùúüûñçßÿœæŕśńṕẃǵǹḿǘẍźḧ·/_,:;'
        const b = 'aaaaaaeeeeiiiioooouuuuncsyoarsnpwgnmuxzh------'
        const p = new RegExp(a.split('').join('|'), 'g')
        return string.toString().toLowerCase()
            .replace(/\s+/g, '-') // Replace spaces with
            .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
            .replace(/&/g, '-and-') // Replace & with ‘and’
            .replace(/[^\w-]+/g, '') // Remove all non-word characters
            .replace(/--+/g, '-') // Replace multiple — with single -
            .replace(/^-+/, '') // Trim — from start of text .replace(/-+$/, '') // Trim — from end of text
    },
    exportToCsv: function (filename, rows) {
        var processRow = function (row) {
            var finalVal = '';
            for (var j = 0; j < row.length; j++) {
                var innerValue = row[j] === null ? '' : row[j].toString();
                if (row[j] instanceof Date) {
                    innerValue = row[j].toLocaleString();
                }
                var result = innerValue.replace(/"/g, '""');
                if (result.search(/("|,|\n)/g) >= 0)
                    result = '"' + result + '"';
                if (j > 0)
                    finalVal += ',';
                finalVal += result;
            }
            return finalVal + '\n';
        };

        var csvFile = '';
        for (var i = 0; i < rows.length; i++) {
            csvFile += processRow(rows[i]);
        }

        var blob = new Blob([csvFile], {type: 'text/csv;charset=utf-8;'});
        if (navigator.msSaveBlob) { // IE 10+
            navigator.msSaveBlob(blob, filename);
        } else {
            var link = document.createElement("a");
            if (link.download !== undefined) { // feature detection
                // Browsers that support HTML5 download attribute
                var url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", filename);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    },
    downloadCsv: function (filename, csvFile) {


        var blob = new Blob([csvFile], {type: 'text/csv;charset=utf-8;'});
        if (navigator.msSaveBlob) { // IE 10+
            navigator.msSaveBlob(blob, filename);
        } else {
            var link = document.createElement("a");
            if (link.download !== undefined) { // feature detection
                // Browsers that support HTML5 download attribute
                var url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", filename);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    }
}


axios.defaults.headers.common['Authorization'] = ''


// before a request is made start the nprogress
axios.interceptors.request.use(config => {
    NProgress.start()
    return config
})

// before a response is returned stop nprogress
axios.interceptors.response.use(response => {

        NProgress.done()

        /* let access_token = localStorage.getItem('access_token')
         if (access_token == '') {
             console.log('not author')
             return;
         }
         let response = await axios
             .post(config.api + "tokens/auth", {
                 refreshToken: access_token,
                 grantType: "refresh_token",
                 clientId: "website"
             })
         console.log('renew access token')
         localStorage.setItem('access_token', response.data.access_token)

         //localStorage.access_token = ;
         //  updateAuthInstant();
         console.log(response.data.access_token)
         axios.defaults.headers.common['Authorization'] = response.data.access_token*/


        return response
    }
)

/*async function (error) {
    const originalRequest = error.config;


    if (error.code != "ECONNABORTED" && error.response.status === 401) {
        if (!originalRequest._retry) {
            //  originalRequest._retry = true;

            //  return await axios(originalRequest);
        } else {
            localStorage.removeItem("access_token")
            console.log("need login")
            return router.push('login')
        }

    }

    return Promise.reject(error);
}*/

Vue.use(Popover)

Vue.prototype.$bus = EventBus
Vue.prototype.$base64 = Base64
Vue.prototype.$http = axios
Vue.prototype.$_ = lodash
Vue.prototype.$config = config
Vue.prototype.$jwt = jwtDecode
Vue.prototype.$author = author
Vue.prototype.$helper = helper

Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
